module.exports = __webpack_public_path__ + "img/end-category.032753ee.png";